import userApi from '@/pages/User/user.api'
import { IUserRouteHistory } from '@/pages/User/user.types'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { useEffect, useState } from 'react'

const useRoutesHistoryWidget = () => {
  const [routesStats, setRoutesStats] = useState<IUserRouteHistory[]>([])
  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    wait(userApi.getSelfRoutesStats(), (resp) => {
      if (resp.status === 'success') setRoutesStats(resp.body)
    })
  }, [])

  return { routesStats, loading }
}

export default useRoutesHistoryWidget
